module.exports = __webpack_public_path__ + "static/media/002.8462b6d7.jpg";